<template>
  <div>
    <topnav></topnav>
    <div class="w1170">
      <div class="contact-box">
        <h1 class="txt54">Contact Us</h1>
        <h3>We’d love to hear from you and see how we can help!</h3>
        <div class="cont-info-form-wrap">
          <div class="cont-info">

            <!-- <div
              class="cont-item"
              v-for="branch in $local.branches"
              :key="branch._id"
            >
              <h3>
                <span v-if="branch._id === '63760c9a5c17be0033d7d88c'">HQ</span>
                {{ branch.name }}
              </h3>
              <div v-html="branch.address"></div>
            </div> -->

            <div class="cont-item">
              <h3>United States and North America:</h3>
              <div>81 Lancaster Ave, Suite 213, Malvern, PA 19355</div>
              <div>1550 Wilson Boulevard, 7th floor Arlington, VA 22209</div>
            </div>

            <div class="cont-item">
              <h3>Europe, Middle East and Africa:</h3>
              <div>HaYarkon st 2, Bnei Brak, Israel </div>
            </div>

            <div class="cont-item">
              <h3>Asia Pacific:</h3>
              <div>91 Springboard, Sky Loft, Creaticity Mall, Off, Airport Road, Yerawada, Pune Maharashtra 411006,
                India</div>
            </div>

          </div>


          <ContactForm></ContactForm>
        </div>
      </div>
    </div>

    <botfooter></botfooter>
  </div>
</template>

<script>
import Botfooter from "@/components/Botfooter.vue";
import Topnav from "@/components/Topnav.vue";
import { buildPath } from "@/utils/buildPath";
import ContactForm from "@/components/ContactForm.vue";
import { getMetatitle, getMetadesc } from "@/utils/getMetadata";

export default {
  props: {
    country: String
  },
  components: {
    Topnav,
    Botfooter,
    ContactForm
  },
  metaInfo() {
    return {
      ssrAppId: "sela",
      ...this.seo({
        title: getMetatitle("contact"),
        description: getMetadesc("contact")
      })
    };
  },
  data: () => ({

  }),
  mounted() {

  },
  methods: {
    buildPath,
  },
  name: "Contact",
};
</script>
<style scoped>
.error-margin {
  margin-bottom: 17px;
}

.contact-box:after {
  width: 0;
}

.cont-item {
  margin-top: 50px;
}
</style>
